import { useState } from "react";
import { Button, Card, CardContent, CardHeader, Typography } from "@mui/material";

import { useFormContext } from "react-hook-form";
import { noteColumns } from "./note-grid-columns";
import { CreateNoteDialog } from "./crate-note.dialog";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { municipalityApiKeyStore } from "../../../../api/masters/municipality-api-key-store";
import { GuardedComponent } from "../../../../components/guarded-component";

interface NoteRequestArgs {
    municipalityID?: number;
    noteTempEntityID?: number;
}

interface CellProps {
    noteData: any;
}

interface CustomGridCellProps {
    field: string;
}

interface NoteComponent {
    name: string;
    setNoteTempID: (noteTempID: string) => void;
    noteRequestArgs: NoteRequestArgs;
}

export const NoteComponent = ({ name, setNoteTempID, noteRequestArgs }: NoteComponent) => {
    const { getValues } = useFormContext();
    const [noteReqArgs, setNoteReqArgs] = useState(noteRequestArgs);
    const [editItem, setEditItem] = useState<any>();

    const handleCreateNote = () => {
        setEditItem({ municipalityID: noteReqArgs?.municipalityID, noteTempEntityID: noteReqArgs?.noteTempEntityID });
    }

    const handleEditNote = (editNote: any) => {
        setEditItem({ ...editNote, municipalityID: noteReqArgs?.municipalityID, noteTempEntityID: noteReqArgs?.noteTempEntityID });
    }

    const handleNoteData = (noteValue: any) => {
        setNoteReqArgs({ ...noteReqArgs, noteTempEntityID: noteValue?.noteTempEntityID });
        setNoteTempID(noteValue?.noteTempEntityID)
    }

    const DescriptionCell = ({ noteData }: CellProps) => {
        const description = noteData?.note;

        return (
            <td>
                <div
                    className="note-html"
                    dangerouslySetInnerHTML={{ __html: description }}
                />
                <style>
                    {`.note-html a {color: blue;text-decoration: none;}
                      .note-html a:hover {text-decoration: underline;}`
                    }
                </style>
            </td >
        );
    };

    const CustomGridCell = ({ field }: CustomGridCellProps) => {
        if (field === 'note') {
            return (dataItem: any) => {
                return <DescriptionCell noteData={dataItem.dataItem} />;
            };
        }
    };
    return (
        <>
            <Card elevation={0} >
                <CardHeader
                    className="subHead"
                    title={
                        <Typography variant="h3" color="textPrimary">
                            NOTE
                        </Typography>
                    }
                    action={
                        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_NOTE]}>
                            <Button
                                className="btnLink"
                                variant="text"
                                sx={{ p: 0, m: 0, mr: 1 }}
                                onClick={handleCreateNote}
                            >
                                Add Notes
                            </Button>
                        </GuardedComponent>
                    }
                />

                <CardContent className="formContainer">
                    <SiTrackGrid
                        fileTitle='municipality_note'
                        dataItemKey="municipalityNoteMappingID"
                        columns={noteColumns}
                        queryConfig={municipalityApiKeyStore.getMunicipalityNotes(noteReqArgs)}
                        customCell={(field) =>
                            CustomGridCell({
                                field,
                            })
                        }
                        onEdit={handleEditNote}
                        deleteMutationConfig={(item) => municipalityApiKeyStore.deleteMunicipalityNote(item.municipalityNoteMappingID)}
                        actionPermissions={{
                            edit: UserPermissionName?.EDIT_NOTE,
                            delete: UserPermissionName?.DELETE_NOTE,
                            export: UserPermissionName.DOWNLOAD_GRID
                        }}
                    />
                </CardContent>
            </Card>

            {editItem && (
                <CreateNoteDialog
                    title={editItem?.municipalityNoteMappingID ? "UPDATE NOTE" : "CREATE NOTE"}
                    config={{
                        saveConfig: editItem.municipalityNoteMappingID
                            ? municipalityApiKeyStore.updateMunicipalityNote()
                            : municipalityApiKeyStore.createMunicipalityNote(),
                        invalidateRoute: () => municipalityApiKeyStore.getMunicipalityNotes(noteReqArgs),
                    }}
                    dataItem={editItem}
                    setNoteValue={handleNoteData}
                    onClosed={() => setEditItem(undefined)} />
            )}
        </>
    );
}